import { render, staticRenderFns } from "./FsFileInfo.vue?vue&type=template&id=b5cca746&"
import script from "./FsFileInfo.vue?vue&type=script&lang=js&"
export * from "./FsFileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports